import React from 'react';
import { Helmet } from 'react-helmet';

const SeoHead = ({ title, description, keywords, image, url, schema }) => {
    const siteName = "Servicios Futura";
    const defaultDescription = "Encuentra tu hogar ideal en El Salvador con Servicios Futura. Propiedades exclusivas, asesoría financiera y servicios integrales.";
    const defaultImage = "https://serviciosfutura.com/og-image.jpg"; // Placeholder
    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || "bienes raíces, el salvador, casas, apartamentos, venta, alquiler, inmobiliaria"} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || window.location.href} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url || window.location.href} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description || defaultDescription} />
            <meta property="twitter:image" content={image || defaultImage} />

            <link rel="canonical" href={url || window.location.href} />

            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SeoHead;
